import breakpoint from '../scripts/breakpoint';
import $ from 'jquery';
import noScroll from '../scripts/noScroll';

var base = '.b-modal';

function showByHash(hash, load) {
	if (!hash || hash === '#' || hash[0] !== '#')
		return;

	var target = $(hash);
	var modal = target.closest(base);
	if (!modal.length)
		return;

	modal.trigger('beforeOpen').addClass('m-show').data('hash', hash);
	noScroll.on(modal.get(0), {reserveScrollBarGap: true});
	modal.trigger('open');

	if (!load || load[0] === '#') {
		load = target.data('load');
	}

	if (load && load[0] !== '#') {
		target.addClass('m-loading').load(load, function(data){
			target.removeClass('m-loading').execInit();
		});
	}
}

$.addInit(function(context){
	$(base, context).each(function(){
		var component = $(this);

		function close() {
			component.removeClass('m-show').transitionDuration(function(){
				noScroll.off(component.get(0));
			});

			if (location.hash === component.data('hash')) {
				history.replaceState({}, document.title, location.pathname + location.search);
			}
		}

		function change() {
			component.removeClass('m-show');
		}

		component.on('close', close);

		component.on('submit', function() {
			this.scrollTop = 0;
		});

		component.click(function(e){
			if (e.target === this) {
				component.trigger('close');
			}
		});

		component.on('click', '.i-modal-close', function(e){
			e.preventDefault();

			component.trigger('close');
		});

		component.on('click', '.i-modal-change', function(e){
			e.preventDefault();

			change();
		});
	});

	if (context === document) {
		$(document).on('click', '.i-modal-link', function(e){
			e.preventDefault();
			var link = $(this);
			showByHash(link.data('target') || link.prop('hash'), link.data('load'));
		});

		$(window).on('hashchange', function(e){
			showByHash(location.hash);
		});

		showByHash(location.hash);
	}
});



//////////////////
// WEBPACK FOOTER
// ./src/components/b-modal.js
// module id = 44
// module chunks = 0